import { useTranslation } from '@crehana/i18n';
import { createImgixPlaceholder, CustomNextImage } from '@crehana/next';

import { FALLBACK } from '../constants';

import { CompaniesLogosProps } from '../types';

const CompaniesLogosDesktop: React.FC<CompaniesLogosProps> = ({
  logos,
  enableLogosFromAdmin,
}) => {
  const { t } = useTranslation();
  console.log('enableLogosFromAdmin', enableLogosFromAdmin);
  return (
    <div className="flex flex-col lg:flex-row w-full justify-center items-center mt-32 mb-24 lg:mb-64 relative">
      <div className="text-center mb-24 lg:mb-0 flex flex-row lg:flex-col items-baseline justify-center lg:items-center lg:mr-64">
        <h3 className="font-h3 text-primary-main text-24 lg:text-20 leading-32 mr-16">
          {t('COMPANIES_LOGOS_TITLE')}
        </h3>
        <span className="font-body4 text-gray-dark lg:text-black lg:mr-12">
          {t('COMPANIES_LOGOS_SUBTITLE')}
        </span>
      </div>
      <div className="flex flex-row flex-shrink-0">
        {logos.map(({ organizationPublicLogo }, i) => {
          const url = organizationPublicLogo?.logo?.url;
          const placeholder = organizationPublicLogo?.logo?.placeholder;

          if (typeof url === 'string') {
            return (
              <div
                key={`org-logos-${i}`}
                className={`${i === logos.length - 1 ? 'mr-0' : 'mr-64'}`}
              >
                <CustomNextImage
                  src={enableLogosFromAdmin ? url : FALLBACK[i] || FALLBACK[0]}
                  blurDataURL={
                    enableLogosFromAdmin
                      ? placeholder
                      : createImgixPlaceholder(FALLBACK[i] || FALLBACK[0])
                  }
                  placeholder="blur"
                  width={96}
                  height={32}
                  objectFit="contain"
                />
              </div>
            );
          } else {
            return null;
          }
        })}
      </div>
    </div>
  );
};

export default CompaniesLogosDesktop;
